import { Stack, useNavigation } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useTheme } from 'smoothie';

import { manualBillAtom } from '../../../../bills/state/BillsAtoms';
import { emptyBillNew } from '../../../../common/utils/billUtils';

export default function ManualBillLayout() {
    const theme = useTheme();
    const navigation = useNavigation();

    const setManualBill = useSetAtom(manualBillAtom);

    // clear the manually created bill if the modal is closed
    navigation.addListener('beforeRemove', (e) => {
        if (['GO_BACK', 'POP'].includes(e.data.action.type))
            setManualBill(emptyBillNew());
    });

    return (
        <Stack
            screenOptions={{
                headerShown: false,
                contentStyle: {
                    backgroundColor: theme.background.get(),
                },
            }}
        />
    );
}
